import React from "react";
import "./Review.css";

const testimonials = [
  {
    name: "Sarah Johnson",
    review: "Absolutely love my custom necklace! The quality is stunning and the design is exactly what I wanted.",
    image: "https://source.unsplash.com/100x100/?woman,face",
    video: "/assets/videos/video3.mp4",
  },
  {
    name: "Michael Smith",
    review: "I gifted my wife a personalized bracelet, and she was thrilled! Highly recommended!",
    image: "https://source.unsplash.com/100x100/?man,face",
    video: "/assets/videos/video2.mp4",
  },
  {
    name: "Emily White",
    review: "The diamonds are so sparkly! The craftsmanship is top-notch, and it was delivered on time.",
    image: "https://source.unsplash.com/100x100/?girl,face",
    video: "/assets/videos/video1.mp4",
  },
];

function Testimonials() {
  return (
    <section className="testimonials">
      <h2 className="testimonials__title">What Our Customers Say</h2>
      <div className="testimonials__container">
        {testimonials.map((testimonial, index) => (
          <div className="testimonial-card fade-in" key={index}>
            <img src={testimonial.image} alt={testimonial.name} className="testimonial__image" />
            <p className="testimonial__review">"{testimonial.review}"</p>
            <h4 className="testimonial__name">{testimonial.name}</h4>
            {testimonial.video && (
              <video controls className="testimonial__video">
                <source src={testimonial.video} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default Testimonials;